export default "__VITE_ASSET__BYi4qgoQ__"